function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:.75px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_22",
  d: "M72.45 189.436l6.946-12 6.938 12z",
  className: "prefix__cls-1",
  "data-name": "Path 22"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_9",
  d: "M0 4.083L0 0",
  className: "prefix__cls-1",
  "data-name": "Line 9",
  transform: "translate(.188)"
});

var SvgEvents = function SvgEvents(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.633,
    height: 12.75,
    viewBox: "0 0 14.633 12.75",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_25",
    "data-name": "Group 25",
    transform: "translate(-72.075 -177.061)"
  }, _ref3, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_24",
    "data-name": "Group 24",
    transform: "translate(79.19 181.485)"
  }, _ref4, /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_14",
    cx: 0.202,
    cy: 0.202,
    r: 0.202,
    "data-name": "Ellipse 14",
    transform: "translate(0 5.656)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".75px"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEvents, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/events.e39645dc.svg";
export { ForwardRef as ReactComponent };